'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable valid-typeof */
var isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 将参数转为 Array 返回
 * @param {*} args
 * @param {*} type
 * @returns
 */
function normalizeArgs(args, type) {
  if (typeof args === 'undefined') {
    return [];
  }
  if (!Array.isArray(args) && (typeof args === 'undefined' ? 'undefined' : _typeof(args)) !== type) {
    isDevelopment && console.warn('\u4F20\u5165\u53C2\u6570\u7C7B\u578B\u9519\u8BEF\uFF0C\u4EC5\u652F\u6301Array\u3001' + type);
    return [];
  }
  if ((typeof args === 'undefined' ? 'undefined' : _typeof(args)) === type) {
    args = [args];
  }
  return args;
}

/**
 * url 是否包含 domain
 * @param {*} url
 * @returns
 */
function containDomain(url) {
  return (/^http/.test(url)
  );
}

/**
 * 获取可能的 时间戳
 * @param {*} str
 * @returns
 */
function getLikeTimestamp(url) {
  var valid = /^.*(\d{13}).*$/.exec(url);
  return valid && valid[1];
}

/**
 * 是否包含时间戳
 * @param {*} url
 * @returns
 */
function containTimestamp(url) {
  var timestamp = getLikeTimestamp(url);
  if (timestamp) {
    var now = Date.now();
    if (now >= timestamp && now - timestamp <= 1000 * 60 * 60 * 24 * 30) {
      return true;
    }
  }
  return false;
}

exports.normalizeArgs = normalizeArgs;
exports.containDomain = containDomain;
exports.containTimestamp = containTimestamp;
exports.getLikeTimestamp = getLikeTimestamp;
exports.isDevelopment = isDevelopment;